<template>
  <div class="pb-32">
    <DataFetcher
      dataKey="deals"
      @fetched="initSlider"
      :emptyChecker="
        (data) =>
          (!Array.isArray(data) && !Array.isArray(data?.result)) ||
          (!data.length && !data?.result?.length)
      "
    >
      <template #default="{ loading, loadingError, refresh, data }">
        <div class="flex flex-col px-6 gap-8">
          <div
            class="w-full p-[25%] relative"
            v-for="(deal, i) in loading
              ? shimmers()
              : Array.isArray(data?.result)
                ? data.result
                : Array.isArray(data)
                  ? data
                  : [{}, {}, {}]"
            :key="i"
            v-show="!cartUtils.isAddedToCart(deal.id)"
          >
            <DealItem :deal="deal" :position="i" />
          </div>
        </div>
      </template>
      <template #empty="{ refresh }">
        <SectionEmptyState
          class="top-0 left-0 w-full h-full pb-[15%]"
          title="De bonnes réductions vous attendent ici"
          description="Les meilleures offres des restaurants arrivent bientôt sur Rapidoo !"
          icon-type="deals"
          @refresh="refresh"
        />
      </template>
      <template #error="{ refresh }">
        <SectionEmptyState
          class="top-0 left-0 w-full h-full pb-[15%]"
          title="De bonnes réductions vous attendent ici"
          description="Revenez bientôt pour découvrir les meilleures réductions !"
          icon-type="deals"
          @refresh="refresh"
        />
      </template>
    </DataFetcher>
    <div class="py-2"></div>
  </div>
</template>

<script setup>
import cartUtils from '@features/shared/libraries/cartUtils';

const shimmers = () => [
  { shimmer: true },
  { shimmer: true },
  { shimmer: true }
];

const initSlider = (data) => {
  console.log('Deals loaded:', data);
};
</script>
